import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { showToast } from '@/lib/custom-toast';
import { API } from '@/App';
import axios from 'axios';

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" xmlns="http://www.w3.org/2000/svg">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const GoogleOAuthButton = ({ text = "Continuar con Google" }) => {
  const [loading, setLoading] = useState(false);
  
  // Detectar si está en Capacitor de forma más robusta (solo para plataformas nativas)
  const isCapacitor = !!(window.Capacitor && (window.Capacitor.getPlatform() === 'android' || window.Capacitor.getPlatform() === 'ios'));

  const handleGoogleLogin = async () => {
    setLoading(true);
    
    try {
      if (isCapacitor) {
        // FLUJO NATIVO (Android/iOS)
        const { GoogleAuth } = await import('@codetrix-studio/capacitor-google-auth');
        
        // Inicialización con Client ID para evitar errores
        await GoogleAuth.initialize({
          clientId: '512352040412-8tagcp1f09susgpf3kfco3juo5ski3aa.apps.googleusercontent.com',
          serverClientId: '512352040412-8tagcp1f09susgpf3kfco3juo5ski3aa.apps.googleusercontent.com',
          scopes: ['profile', 'email']
        });

        // Iniciar sesión nativa
        const googleUser = await GoogleAuth.signIn();
        const idToken = googleUser.authentication.idToken;

        if (!idToken) {
          throw new Error('No se recibió el token de Google');
        }

        // Enviar el idToken al backend (usaremos un nuevo endpoint para móvil)
        const response = await axios.post(`${API}/auth/google/mobile`, { idToken });
        
        const { access_token } = response.data;
        
        // Guardar token y redirigir
        localStorage.setItem('token', access_token);
        window.location.href = '/dashboard';
        return;
      }

      // FLUJO WEB (Navegador)
      sessionStorage.setItem('google_auth_pending', 'true');
      const urlResponse = await axios.get(`${API}/auth/google/url`);
      const googleAuthUrl = urlResponse.data.url;
      window.location.href = googleAuthUrl;
      
    } catch (error) {
      console.error('Google Auth Error:', error);
      showToast.error(error.message || 'Error al iniciar sesión con Google');
      setLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleGoogleLogin}
      disabled={loading}
      variant="outline"
      className="w-full border-2 border-slate-300 hover:bg-slate-50 flex items-center justify-center gap-3"
      size="lg"
    >
      {loading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <>
          <GoogleIcon />
          <span className="font-medium">{text}</span>
        </>
      )}
    </Button>
  );
};

export default GoogleOAuthButton;
